export default __webpack_public_path__ + "static/media/uit-site.96b3a68a.png";